import React, { useRef, useEffect, useCallback } from 'react'
import './Backdrop.sass'

function Backdrop({ show, close = () => null, children, className, transparentBackDrop, style }) {
  const backdropRef = useRef()

  const handleClickOutside = useCallback(
    (event) => {
      if (backdropRef && backdropRef.current === event.target) {
        close()
      }
    },
    [close]
  )

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [handleClickOutside])

  const classes = ['Backdrop']
  if (transparentBackDrop) classes.push('Backdrop_theme_transparent')
  if (className) classes.push(className)

  return show ? (
    <div ref={backdropRef} className={classes.join(' ')} style={style}>
      {children}
    </div>
  ) : null
}

export default Backdrop
